import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getPropertySuccess } from '../actions/propertyActions';
import * as types from '../actions/actionType';
import { withApiErrorHandling } from '../helpers/sagaHelper';
import session from 'containers/App/session';
import { statsService } from 'utils/api';

export function* getEventsForDay(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchEventsForDay() {
        const response = yield call(statsService({ token, propertyId: action.id }).getEventsBetweenDates, {
            start: action.startDate,
            end: action.endDate,
        });
        yield put(getPropertySuccess(types.GET_EVENTS_BY_DAY_SUCCESS, response.data));
    });
}

export function* watchGetEventsForDay() {
    yield takeEvery(types.GET_EVENTS_BY_DAY, getEventsForDay);
}
